// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; 

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCZwcTkBvwBPoXxDOyryubuRwJUZbLYOJw",
  authDomain: "gestorpme-a2e93.firebaseapp.com",
  projectId: "gestorpme-a2e93",
  storageBucket: "gestorpme-a2e93.appspot.com",
  messagingSenderId: "69369213961",
  appId: "1:69369213961:web:f19a23743b5cfb9ef4b4d8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

//Initialize Firestore
const db = getFirestore(app);

// Initialize Storage
const storage = getStorage(app);

//Authentication
const auth = getAuth();

export {auth, db, storage, firebaseConfig};